import React, { Component } from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import Cookies from "universal-cookie";
//import { Link } from "react-router-dom";
import ReactModal from 'react-modal';
import FooterShade from "../partials/footer";
import TopShade from "../partials/topshade";

import Carousel from 'react-bootstrap/Carousel';

const cookies = new Cookies();
//console.log(cookies.get("lang"));

const TelpasQUERY = gql`
query telpas($lang: LanguageCodeFilterEnum) {
  themeGeneralSettings {
    optionsPage {
      singlePostShareButtonsText
      telpasDescriptionEn
      telpasDescriptionLv
      telpasEn
      telpasLv
      telpasMainImage {
        sourceUrl(size: LARGE)
      }
      telpasPlatibaEn
      telpasPlatibaLv
      telpasRezervetPogaEn
      telpasRezervetPogaLv
      telpasSedvietasEn
      telpasSedvietasLv
      telpasSubtitleLv
      telpasSubtitleEn
      telpasUznemsanaEn
      telpasUznemsanaLv
    }
  }
  telpas(where: { language: $lang }) {
    edges {
      node {
        title(format: RENDERED)
        telpa_single {
          apraksts
          uznemsana
          stavs
          sedvietas
          platiba
          piezimes
          bookingUrl
          foto {
            sourceUrl
          }
        }
      }
    }
  }
}


`;

ReactModal.setAppElement('#root');
class TelpasMatchList extends Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
      iframeData: null
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleOpenModal(url) {
    this.setState({ showModal: true });
    this.setState({ iframeData: url });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }


  render() {
    const {
      data: { loading, errors, telpas }
    } = this.props;

    const customStyles = {
      content: {
        top: '50%',
        left: '50%',
        width: '80vw',
        height: '80vh',
        zIndex: '999',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        overflowX: 'hidden',
        transform: 'translate(-50%, -50%)',


      }
    };
    // const images = match.node.telpa_single.foto.map((prop, i) => {
    //   //console.log(prop.sourceUrl);
    //   return (

    //     <Carousel.Item
    //       key={
    //         i
    //       }
    //       style={
    //         {
    //           backgroundImage: `url(${prop.sourceUrl})`
    //         }
    //       } >
    //     </Carousel.Item>
    //   );
    // });
    
    //console.log(this.props.data);
    return (
      <div id="telpas_wrap"
        className="mt-5 container blogs-container"
        data-headertitle={
          cookies.get("lang") === "LV" ? "Telpas" : cookies.get("lang") === "EN" ? "Premises" : null
        }>
        {!loading && telpas && (
          <div id="carouselId" className="carousel slide narrow-carousel" data-ride="carousel">
            <TopShade />
            <div className="carousel-inner" role="listbox">
              <div
                className={`carousel-item active`}

                style={{
                  backgroundImage: `url(${this.props.data.themeGeneralSettings.optionsPage.telpasMainImage[0].sourceUrl})`
                }}
              ></div>
              <div className="carousel-item-herotextnarrow-wrap">
                <div className="herotext">{cookies.get("lang") === "LV" &&
                  this.props.data.themeGeneralSettings.optionsPage.telpasLv}
                  {cookies.get("lang") === "EN" &&
                    this.props.data.themeGeneralSettings.optionsPage.telpasEn}</div>
              </div>
            </div>
            <FooterShade />
          </div>
        )}
        {!loading && this.props.data.themeGeneralSettings.optionsPage.telpasDescriptionLv && (
          <div className="row justify-content-center ">
            <div className="col-12 col-md-8 mt-5 telpasDescrWrap">
              <h2>{cookies.get("lang") === "LV" &&
                this.props.data.themeGeneralSettings.optionsPage.telpasSubtitleLv}
                {cookies.get("lang") === "EN" &&
                  this.props.data.themeGeneralSettings.optionsPage.telpasSubtitleEn}</h2>
              {cookies.get("lang") === "LV" &&
                <p dangerouslySetInnerHTML={{ __html: this.props.data.themeGeneralSettings.optionsPage.telpasDescriptionLv }} />}
              {cookies.get("lang") === "EN" &&
                <p dangerouslySetInnerHTML={{ __html: this.props.data.themeGeneralSettings.optionsPage.telpasDescriptionEn }} />}
            </div>
          </div>
        )}

        {loading && <div className="loader" />}
        {errors && <div className="errors">...</div>}

        {!loading && !telpas && <span className="none">Nav telpu...</span>}

        {!loading &&
          telpas &&
          telpas.edges.map((match, i) => (
            <div className="row" key={i}>
              
              <div
                className="col-12 col-sm-6 blogs-single-card telpa-single-card"
              >
                {/* <div
                  className="blogs-single-card-wrap telpa-single-card-wrap"
                  style={{
                    backgroundImage: `url(${match.node.telpa_single.foto[0].sourceUrl})`
                  }}
                ></div> */}
                <Carousel
                  id={'carousel-' + i} className="narrow-carousel" controls={false} fade={true} interval={6000} pause={false}
                >
                  {/* {console.log(match.node.telpa_single.foto)} */}
                  {match.node.telpa_single.foto.map((prop, i) => {
                    return (

                      <Carousel.Item
                        key={
                          i
                        }
                        style={
                          {
                            backgroundImage: `url(${prop.sourceUrl})`
                          }
                        } >
                      </Carousel.Item>
                    );
                  })}

                </Carousel>
              </div>
              <div
                className="col-12 col-sm-6 blogs-single-card-text telpa-single-card-text"
              >
                <h2><span className="ytitle">{match.node.title}</span>
                  {match.node.telpa_single.stavs && <span> - {match.node.telpa_single.stavs} </span>}
                </h2>
                <div
                  className="blogs-single-card-text-content"
                  dangerouslySetInnerHTML={{ __html: match.node.telpa_single.apraksts }}
                />
                {match.node.telpa_single.platiba && (<p><span className="ytitle spanblock">{cookies.get("lang") === "LV" &&
                  this.props.data.themeGeneralSettings.optionsPage.telpasPlatibaLv}
                  {cookies.get("lang") === "EN" &&
                    this.props.data.themeGeneralSettings.optionsPage.telpasPlatibaEn}</span><span className="telpa_value">{match.node.telpa_single.platiba}</span></p>)
                }
                {match.node.telpa_single.uznemsana && (<p><span className="ytitle spanblock">{cookies.get("lang") === "LV" &&
                  this.props.data.themeGeneralSettings.optionsPage.telpasUznemsanaLv}
                  {cookies.get("lang") === "EN" &&
                    this.props.data.themeGeneralSettings.optionsPage.telpasUznemsanaEn}</span><span className="telpa_value">{match.node.telpa_single.uznemsana}</span></p>)
                }
                {match.node.telpa_single.sedvietas && (<p><span className="ytitle spanblock">{cookies.get("lang") === "LV" &&
                  this.props.data.themeGeneralSettings.optionsPage.telpasSedvietasLv}
                  {cookies.get("lang") === "EN" &&
                    this.props.data.themeGeneralSettings.optionsPage.telpasSedvietasEn}</span><span className="telpa_value">{match.node.telpa_single.sedvietas}</span></p>)
                }
                {match.node.telpa_single.piezimes && (<span className="telpa_value"><p>{match.node.telpa_single.piezimes}</p></span>)
                }

                {match.node.telpa_single.bookingUrl && (
                  <div className="bookingBtnWrap mb-5">

                    <div onClick={() => this.handleOpenModal(match.node.telpa_single.bookingUrl)}
                      className="bookingButton" rel="noopener noreferrer">{cookies.get("lang") === "LV" &&
                        this.props.data.themeGeneralSettings.optionsPage.telpasRezervetPogaLv}
                      {cookies.get("lang") === "EN" &&
                        this.props.data.themeGeneralSettings.optionsPage.telpasRezervetPogaEn}</div>
                    <div>
                      {/* <button onClick={this.handleOpenModal}>Trigger Modal</button> */}

                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        {!loading &&
          telpas &&
          <ReactModal
            isOpen={this.state.showModal}
            contentLabel="Minimal Modal Example"
            style={customStyles}
          >
            <div className="resp-container">
              <iframe title="telpas_iframe" className="resp-iframe" src={this.state.iframeData} gesture="media" allow="encrypted-media" allowFullScreen></iframe>
            </div>

            <span className="close" onClick={this.handleCloseModal}></span>
          </ReactModal>
        }
      </div>
    );
  }
}

const cookieLang = cookies.get("lang");

export default graphql(TelpasQUERY, {
  options: {
    variables: {
      lang: cookieLang
    }
  }
})(TelpasMatchList);
